import React, { useMemo } from 'react';
import { lastDayOfMonth, eachWeekOfInterval, eachDayOfInterval, endOfWeek, getISOWeek, isSameMonth, format, isPast, isSameDay } from 'date-fns';
import { MonthWrapper, MonthTitle, Month, MonthFooter } from './style.js';
import MonthRow from './MonthRow.js';
import MonthHeader from './MonthHeader.js';
import { jsxs, jsx } from 'react/jsx-runtime';

/* eslint-disable react/display-name */
var monthNames = {
  1: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
  3: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
  11: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
  15: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
  18: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
};
var getMonthData = function getMonthData(inputDate, validDates, disableHistoricalDates) {
  var lastDate = lastDayOfMonth(inputDate);
  var weeks = eachWeekOfInterval({
    start: inputDate,
    end: lastDate
  }, {
    weekStartsOn: 1
  });
  var now = new Date(Date.now());
  return weeks.map(function (firstDayInWeek) {
    var days = eachDayOfInterval({
      start: firstDayInWeek,
      end: endOfWeek(firstDayInWeek, {
        weekStartsOn: 1
      })
    });
    return {
      weekNr: getISOWeek(firstDayInWeek),
      days: days.map(function (day) {
        if (isSameMonth(inputDate, day)) {
          var dateString = format(day, 'yyyy-MM-dd');
          var disabled = !!validDates.length && validDates.indexOf(dateString) === -1;
          if (disableHistoricalDates) {
            if (isPast(day) && !isSameDay(day, now)) {
              disabled = true;
            }
          }
          return {
            date: day.getDate(),
            disabled: disabled,
            fullDate: dateString
          };
        }
        return null;
      })
    };
  });
};
var MonthBlock = /*#__PURE__*/React.memo(function (_ref) {
  var month = _ref.month,
    year = _ref.year,
    siteId = _ref.siteId,
    validDates = _ref.validDates,
    selectedDate = _ref.selectedDate,
    selectedDateInterval = _ref.selectedDateInterval,
    onChange = _ref.onChange,
    monthFooter = _ref.monthFooter,
    selectedMonths = _ref.selectedMonths,
    disableHistoricalDates = _ref.disableHistoricalDates;
  if (month > 11 || month < 0) {
    throw new TypeError('Month must be between 0-11');
  }
  var inputDate = useMemo(function () {
    var res = new Date();
    res.setFullYear(year, month, 1);
    return res;
  }, [year, month]);
  var monthData = useMemo(function () {
    return getMonthData(inputDate, validDates, disableHistoricalDates);
  }, [inputDate, validDates, disableHistoricalDates]);
  var monthName = monthNames[siteId][month];
  return /*#__PURE__*/jsxs(MonthWrapper, {
    children: [/*#__PURE__*/jsx(MonthTitle, {
      children: "".concat(monthName, " ").concat(year)
    }), /*#__PURE__*/jsxs(Month, {
      children: [/*#__PURE__*/jsx(MonthHeader, {
        siteId: siteId
      }), monthData.map(function (week) {
        return /*#__PURE__*/jsx(MonthRow, {
          selectedDay: selectedDate,
          selectedMonths: selectedMonths,
          selectedDateInterval: selectedDateInterval,
          weekNumber: week.weekNr,
          onSelectDay: onChange,
          weekDays: week.days,
          month: month
        }, "week-".concat(week.weekNr));
      })]
    }), /*#__PURE__*/jsx(MonthFooter, {
      children: monthFooter({
        month: month,
        year: year,
        monthName: monthName
      })
    })]
  });
});
MonthBlock.defaultProps = {
  siteId: 1,
  validDates: [],
  selectedDate: '',
  selectedDateInterval: {},
  onChange: function onChange() {},
  monthFooter: function monthFooter() {},
  selectedMonths: [],
  disableHistoricalDates: false
};
var MonthBlock$1 = MonthBlock;

export { MonthBlock$1 as default };
//# sourceMappingURL=MonthBlock.js.map
